<app-header></app-header>

<iframe class="privacy-content" src="https://www.iubenda.com/privacy-policy/34576083"></iframe>

<!--<ng-container *ngIf="privacyContent; else spinner">
  <div [innerHTML]="privacyContent"></div>
</ng-container>

<ng-template #spinner>
  <app-scotty-spinner diameter="25" text="Loading privacy policy..."></app-scotty-spinner>
</ng-template>-->
